/*
 * Announcement bar vastzetten bovenaan het scherm.
 *
 * Eerste poging was position:sticky op de sectie-wrapper. Dat werkt niet:
 * een sticky element plakt alleen binnen zijn eigen ouder, en die ouder is
 * hier .header-sections — precies zo hoog als de header zelf. Zodra je daar
 * voorbij scrollt, houdt de sticky-context op en scrollt de balk alsnog weg.
 *
 * Daarom position:fixed, met een spacer die de vrijgekomen ruimte in de
 * document-flow opvult zodat de pagina niet omhoog springt. De hoogte gaat
 * als --announcement-h naar de CSS, zodat de header eronder uitlijnt.
 */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('.announcement__wrapper--top') ||
              document.querySelector('.announcement__wrapper');
    if (!bar) return;

    var section = bar.closest('.shopify-section') || bar.parentElement;
    if (!section || section.classList.contains('brand-sticky-announcement')) return;

    var spacer = document.createElement('div');
    spacer.className = 'brand-sticky-announcement__spacer';
    spacer.setAttribute('aria-hidden', 'true');
    section.parentNode.insertBefore(spacer, section.nextSibling);

    function zet(h) {
      h = Math.round(h);
      if (!h) return;
      spacer.style.height = h + 'px';
      document.documentElement.style.setProperty('--announcement-h', h + 'px');
      // Pas fixed maken als de spacer zijn plek inneemt; eerder schoof de
      // pagina 41 px omhoog en terug (CLS 0,05 in PageSpeed).
      section.classList.add('brand-sticky-announcement');
    }

    function sync() {
      zet(section.getBoundingClientRect().height);
    }

    /*
     * PAGESPEED (15-10-2026). Hier stond eerst een directe sync() bij
     * DOMContentLoaded. Die getBoundingClientRect vlak na het toevoegen van de
     * klasse en de spacer dwong de browser de hele pagina op te meten voordat
     * de CSS rond was: 303 ms geforceerde reflow op de productpagina in
     * PageSpeed. De ResizeObserver meldt de hoogte na de eerste layout, terwijl
     * de balk nog gewoon in de flow staat; pas dan worden spacer en fixed samen
     * gezet, dus zonder sprong en zonder die extra meting.
     */
    if (window.ResizeObserver) {
      new ResizeObserver(function (entries) {
        var e = entries[entries.length - 1];
        zet(e.borderBoxSize && e.borderBoxSize[0] ? e.borderBoxSize[0].blockSize : e.contentRect.height);
      }).observe(section);
    } else {
      sync();
      window.addEventListener('resize', sync, { passive: true });
      window.addEventListener('load', sync);
    }

    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:section:unload', sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * Het uitklapmenu niet meteen sluiten als de muis het hoofditem verlaat.
 *
 * Broadcast sluit op mouseleave van het hoofditem, zonder vertraging. Het item
 * "Men" is ruim 50 pixels breed, het paneel eronder 244. Wie schuin naar
 * rechtsonder beweegt, komt eerst over "All clothing" en verlaat zo het item
 * voordat hij het paneel bereikt — en het menu is dicht. De CSS-brug in
 * brand-menu-dropdown.css dekt alleen de beweging recht naar beneden.
 *
 * Daarom: de mouseleave van Broadcast in de capture-fase onderscheppen en pas
 * na LOSLAAT_MS doorgeven, tenzij de muis intussen terug is (het paneel zit in
 * het item, dus binnenkomen in het paneel telt als terugkomen). Gaat de muis
 * naar een ander hoofditem met een uitklapmenu, dan sluit het vorige meteen,
 * anders staan er twee panelen over elkaar.
 */
(function () {
  'use strict';

  var LOSLAAT_MS = 350;
  var TRIGGER = '[data-hover-disclosure-toggle]';
  var wachtend = null;
  var timer = 0;

  function doorgeven(el) {
    var ev = new MouseEvent('mouseleave');
    ev.brandDoorgelaten = true;
    el.dispatchEvent(ev);
  }

  function isTrigger(t) {
    return t instanceof Element && t.matches(TRIGGER);
  }

  document.addEventListener('mouseleave', function (e) {
    if (e.brandDoorgelaten || !isTrigger(e.target)) return;
    // Op een aanraakscherm opent Broadcast via touchstart; daar niets uitstellen.
    if (!window.matchMedia('(hover: hover)').matches) return;
    e.stopPropagation();
    var el = e.target;
    clearTimeout(timer);
    if (wachtend && wachtend !== el) doorgeven(wachtend);
    wachtend = el;
    timer = setTimeout(function () {
      wachtend = null;
      if (!el.matches(':hover')) doorgeven(el);
    }, LOSLAAT_MS);
  }, true);

  document.addEventListener('mouseenter', function (e) {
    if (!wachtend || !isTrigger(e.target)) return;
    clearTimeout(timer);
    var vorige = wachtend;
    wachtend = null;
    if (vorige !== e.target) doorgeven(vorige);
  }, true);
})();
